import React from 'react';

import './About.css';

export default function About() {
  return (
    <div className="about">
      <img src={require('./media/images/aboutme.jpg')} alt="Morena" />

      <div className="text">
        <h3>SOBRE MÍ</h3>

        <p>
          Soy Morena Sanchez, nacida en Buenos Aires, Argentina fotógrafa y
          filmmaker establecida en la ciudad de La Falda, Córdoba, Argentina.
        </p>

        <p>
          Inicié mi trayectoria fotográfica a mediados de 2016 cuando me regalan
          mi primera cámara, Nikon D5200.
        </p>

        <p>
          Actualmente soy recibida de la Tecnicatura Superior en Fotografía de
          la Universidad Provincial de Córdoba y realizo trabajos tanto en el
          área de la fotografía como en video.
        </p>
      </div>
    </div>
  );
}
